class CounterForDirective {
    static $inject = ['$parse'];

    constructor($parse) {
        this.$parse = $parse;
    }

    compile() {
        return this.link.bind(this);
    }

    link(scope, element, attrs) {
        const ngModel = this.$parse(attrs.counterFor)(scope);

        if(!ngModel) {
            throw new TypeError(`Invalid model supplied to counterFor directive: ${attrs.counterFor}.`);
        }

        ngModel.$validators.counterFor = (value) => {
            if(value !== null && value !== undefined) {
                const number = parseInt(attrs.ngMaxlength || attrs.maxTags) - value.length;
                element.text(number);
            }
            return true;
        };

        element.text(parseInt(attrs.ngMaxlength));
    }

    static factory($parse) {
        'ngInject';
        return new CounterForDirective($parse);
    }
}

// Explicit DI annotation for factory used in angular.directive registration
CounterForDirective.factory.$inject = ['$parse'];

export default CounterForDirective.factory;
